import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'FileEdit',
  data: function data() {
    return {
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      title: '',
      enumList: [],
      fileList: [],
      form: {
        fileId: null,
        createTime: null,
        isDel: null,
        saveSource: '',
        url: '',
        name: '',
        suffix: '',
        type: '',
        source: ''
      },
      rules: {
        fileId: [{
          required: true,
          message: '请输入文件id',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        isDel: [{
          required: true,
          message: '请输入删除标记',
          trigger: 'blur'
        }],
        saveSource: [{
          required: true,
          message: '请输入存放源',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入文件名称',
          trigger: 'blur'
        }],
        suffix: [{
          required: true,
          message: '请输入后缀',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请输入类型',
          trigger: 'blur'
        }],
        source: [{
          required: true,
          message: '请输入来源',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.form = res.body;
      this.form.urlImg = res.body.dnsUrl + '/' + res.body.url;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    initEunmData: function initEunmData() {
      this.getEnumList('file_type');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      this.initEunmData();
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.fileId = null;
      this.form.createTime = null;
      this.form.isDel = null;
      this.form.saveSource = null;
      this.form.url = null;
      this.form.name = null;
      this.form.suffix = null;
      this.form.type = null;
      this.form.source = null;
      this.form.urlImg = null;
    },
    setData: function setData(data) {
      this.initEunmData();
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.fileId = data.fileId;
      this.form.createTime = data.createTime;
      this.form.isDel = data.isDel;
      this.form.saveSource = data.saveSource;
      this.form.url = data.url;
      this.form.name = data.name;
      this.form.suffix = data.suffix;
      this.form.type = data.type;
      this.form.source = data.source;
      this.form.urlImg = process.env.VUE_APP_DOWNLOAD_URL + '/' + data.url;
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_FILE(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_FILE(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.fileId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
            _this4.fileList = [];
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};